<div class="cortes-proveedor-container">
  <mat-card class="cortes-proveedor-card">
    <mat-card-header class="cortes-proveedor-header">
      <div>
        <mat-card-title>Cortes de Proveedor</mat-card-title>
        <mat-card-subtitle>Gestiona los pagos a tus proveedores por productos vendidos</mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-card-content class="cortes-proveedor-content">
      <div class="period-controls">
        <button mat-icon-button color="primary" (click)="changePeriod('prev')" [disabled]="!filterForm.get('startDate')?.value">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="period-text">
          <h3>{{ periodTitle }}</h3>
          <p [class.clickable-date]="isDayView" (click)="openDayPicker()" *ngIf="isDayView; else normalSubtitle">
            {{ periodSubtitle }}
            <mat-icon class="date-picker-icon">calendar_today</mat-icon>
          </p>
          <ng-template #normalSubtitle>
            <p>{{ periodSubtitle }}</p>
          </ng-template>
        </div>
        <button mat-icon-button color="primary" (click)="changePeriod('next')" [disabled]="!filterForm.get('startDate')?.value">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <!-- Date picker oculto para selección de día -->
      <input matInput [matDatepicker]="dayPicker" style="display: none;" [value]="filterForm.get('startDate')?.value" (dateChange)="onDaySelected($event)">
      <mat-datepicker #dayPicker [startAt]="filterForm.get('startDate')?.value"></mat-datepicker>

      <form [formGroup]="filterForm" class="cortes-filter">
        <mat-form-field appearance="outline">
          <mat-label>Selecciona un proveedor</mat-label>
          <mat-select formControlName="proveedorId" [disabled]="loadingProviders">
            <mat-option value="">-- Selecciona --</mat-option>
            <mat-option *ngFor="let proveedor of providers" [value]="proveedor.id">
              {{ proveedor.nombre }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="!loadingProviders">Total: {{ providers.length }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Vista del reporte</mat-label>
          <mat-select formControlName="viewType">
            <mat-option value="today">Hoy</mat-option>
            <mat-option value="week">Semana actual</mat-option>
            <mat-option value="month">Mes actual</mat-option>
            <mat-option value="custom">Personalizado</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="filterForm.get('viewType')?.value === 'custom'">
          <mat-label>Fecha inicial</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="filterForm.get('viewType')?.value === 'custom'">
          <mat-label>Fecha final</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <mat-checkbox formControlName="soloPendientes">
          Solo productos pendientes de pago
        </mat-checkbox>

        <mat-form-field appearance="outline">
          <mat-label>Buscar por nombre</mat-label>
          <input matInput formControlName="nombre" placeholder="Nombre del producto" (keyup.enter)="cargarProductosVendidos()">
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint>Presiona Enter para buscar</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Buscar por etiqueta</mat-label>
          <input matInput formControlName="etiqueta" placeholder="Etiqueta del producto" (keyup.enter)="cargarProductosVendidos()">
          <mat-icon matSuffix>label</mat-icon>
          <mat-hint>Presiona Enter para buscar</mat-hint>
        </mat-form-field>

        <button
          *ngIf="filterForm.get('proveedorId')?.value"
          type="button"
          mat-flat-button
          color="primary"
          (click)="cargarProductosVendidos()"
          [disabled]="loadingProductos || !filterForm.get('startDate')?.value || !filterForm.get('endDate')?.value">
          <mat-icon>search</mat-icon>
          Buscar Productos
        </button>
      </form>

      <ng-container *ngIf="loadingProductos">
        <div class="loading-state">
          <mat-spinner diameter="48"></mat-spinner>
          <p>Cargando productos vendidos...</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingProductos && filterForm.get('proveedorId')?.value">
        <div class="cortes-scroll">
          <!-- Sección de Productos Vendidos -->
          <section class="productos-section" *ngIf="productosFiltrados.length > 0">
            <div class="section-header">
              <h3>Productos Vendidos</h3>
              <div class="header-actions">
                <span class="total-selected" *ngIf="productosSeleccionados.length > 0">
                  {{ productosSeleccionados.length }} seleccionados - Total: {{ calcularTotalSeleccionado() | currency }}
                </span>
                <div class="selection-buttons">
                  <button
                    mat-stroked-button
                    (click)="toggleSeleccionarTodos(true)"
                    [disabled]="productosFiltrados.length === 0">
                    <mat-icon>check_box</mat-icon>
                    Seleccionar Todos
                  </button>
                  <button
                    mat-stroked-button
                    (click)="toggleSeleccionarTodos(false)"
                    [disabled]="productosSeleccionados.length === 0">
                    <mat-icon>check_box_outline_blank</mat-icon>
                    Deseleccionar Todos
                  </button>
                </div>
                <button
                  *ngIf="isAdministrador"
                  mat-flat-button
                  color="primary"
                  (click)="toggleFormularioCorte()"
                  [disabled]="productosSeleccionados.length === 0">
                  <mat-icon>add</mat-icon>
                  Crear Corte
                </button>
              </div>
            </div>

            <!-- Formulario para crear corte -->
            <mat-card class="corte-form-card" *ngIf="mostrarFormularioCorte">
              <form [formGroup]="corteForm">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Observaciones</mat-label>
                  <textarea matInput formControlName="observaciones" rows="3"></textarea>
                </mat-form-field>
                <div class="form-actions">
                  <button mat-button (click)="toggleFormularioCorte()">Cancelar</button>
                  <button mat-flat-button color="primary" (click)="crearCorte()">
                    Crear Corte
                  </button>
                </div>
              </form>
            </mat-card>

            <!-- Tabla de productos -->
            <mat-card class="table-card">
              <div class="table-scroll mobile-table-wrapper">
                <table mat-table [dataSource]="productosFiltrados" class="mat-elevation-z8">
                  <ng-container matColumnDef="seleccionar">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        [checked]="productosSeleccionados.length === productosFiltrados.length && productosFiltrados.length > 0"
                        [indeterminate]="productosSeleccionados.length > 0 && productosSeleccionados.length < productosFiltrados.length"
                        (change)="toggleSeleccionarTodos($event.checked)">
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let producto">
                      <mat-checkbox
                        [checked]="estaSeleccionado(producto.detalleVentaId)"
                        (change)="seleccionarProducto(producto.detalleVentaId)">
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="producto">
                    <th mat-header-cell *matHeaderCellDef>Producto</th>
                    <td mat-cell *matCellDef="let item">
                      <strong>{{ item.productoNombre || item.nombre || 'Sin nombre' }}</strong>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fechaVenta">
                    <th mat-header-cell *matHeaderCellDef>Fecha de venta</th>
                    <td mat-cell *matCellDef="let item">
                      {{ (item.fechaVenta || item.fecha || item.createdAt) | date:'dd/MM/yyyy HH:mm' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="cantidad">
                    <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                    <td mat-cell *matCellDef="let item">{{ item.cantidad }}</td>
                  </ng-container>

                  <ng-container matColumnDef="precioUnitario">
                    <th mat-header-cell *matHeaderCellDef>Precio unitario</th>
                    <td mat-cell *matCellDef="let item">{{ item.precioUnitario | currency }}</td>
                  </ng-container>

                  <ng-container matColumnDef="subtotal">
                    <th mat-header-cell *matHeaderCellDef>Subtotal</th>
                    <td mat-cell *matCellDef="let item">
                      <strong>{{ item.subtotal | currency }}</strong>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                    <td mat-cell *matCellDef="let item">
                      <mat-chip [class]="item.pagado ? 'chip-paid' : 'chip-pending'">
                        {{ item.pagado ? 'Pagado' : 'Pendiente' }}
                      </mat-chip>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['seleccionar','producto','fechaVenta','cantidad','precioUnitario','subtotal','estado']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['seleccionar','producto','fechaVenta','cantidad','precioUnitario','subtotal','estado'];"></tr>
                </table>
              </div>
            </mat-card>
          </section>

          <!-- Sección de Cortes -->
          <section class="cortes-section">
            <div class="section-header">
              <h3>Cortes Creados</h3>
              <div class="cortes-loading" *ngIf="loadingCortes">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
            </div>

            <div class="loading-state" *ngIf="loadingCortes && cortes.length === 0">
              <mat-spinner diameter="48"></mat-spinner>
              <p>Cargando cortes...</p>
            </div>

            <div class="cortes-grid" *ngIf="!loadingCortes || cortes.length > 0">
              <mat-card class="corte-card" *ngFor="let corte of cortes">
                <mat-card-header>
                  <mat-card-title>Corte #{{ corte.id }}</mat-card-title>
                  <mat-card-subtitle>{{ corte.proveedor?.nombre || corte.proveedorNombre || 'N/A' }}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="corte-info">
                    <div class="info-row">
                      <span class="label">Monto Total:</span>
                      <span class="value">{{ corte.montoTotal | currency }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">Monto Pagado:</span>
                      <span class="value success">{{ corte.montoPagado | currency }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">Saldo Pendiente:</span>
                      <span class="value" [class.pending]="getSaldoPendiente(corte) > 0" [class.success]="getSaldoPendiente(corte) <= 0">
                        {{ getSaldoPendiente(corte) | currency }}
                      </span>
                    </div>
                    <div class="info-row">
                      <span class="label">Estado:</span>
                      <mat-chip [class]="(corte.estado || getEstadoCorte(corte)).toLowerCase()">
                        {{ corte.estado || getEstadoCorte(corte) }}
                      </mat-chip>
                    </div>
                    <div class="info-row" *ngIf="corte.observaciones">
                      <span class="label">Observaciones:</span>
                      <span class="value">{{ corte.observaciones }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">Fecha:</span>
                      <span class="value">{{ corte.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                    </div>
                  </div>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-stroked-button color="primary" (click)="verCorte(corte)" class="action-button">
                    <mat-icon>visibility</mat-icon>
                    <span class="button-text">Ver Detalles</span>
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="toggleFormularioPago(corte)"
                    [disabled]="getSaldoPendiente(corte) <= 0"
                    class="action-button">
                    <mat-icon>payment</mat-icon>
                    <span class="button-text">Pagar</span>
                  </button>
                </mat-card-actions>
              </mat-card>
            </div>

            <!-- Formulario para pagar corte -->
            <mat-card class="pago-form-card" *ngIf="mostrarFormularioPago && corteSeleccionado">
              <mat-card-header>
                <mat-card-title>Pagar Corte #{{ corteSeleccionado.id }}</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <form [formGroup]="pagoForm">
                  <div class="pago-info">
                    <p><strong>Monto Total:</strong> {{ corteSeleccionado.montoTotal | currency }}</p>
                    <p><strong>Monto Pagado:</strong> {{ corteSeleccionado.montoPagado | currency }}</p>
                    <p><strong>Saldo Pendiente:</strong> {{ getSaldoPendiente(corteSeleccionado) | currency }}</p>
                  </div>

                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Monto a pagar</mat-label>
                    <input matInput type="number" formControlName="monto" min="0" [max]="getSaldoPendiente(corteSeleccionado)">
                    <mat-hint>Máximo: {{ getSaldoPendiente(corteSeleccionado) | currency }}</mat-hint>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Observaciones</mat-label>
                    <textarea matInput formControlName="observaciones" rows="3"></textarea>
                  </mat-form-field>

                  <div class="form-actions">
                    <button mat-button (click)="toggleFormularioPago(corteSeleccionado!)">Cancelar</button>
                    <button mat-flat-button color="primary" (click)="pagarCorte()">
                      <mat-icon>payment</mat-icon>
                      Registrar Pago
                    </button>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>
          </section>

          <!-- Mensaje cuando no hay datos -->
          <div class="empty-state" *ngIf="productosFiltrados.length === 0 && cortes.length === 0 && !loadingProductos && !loadingCortes">
            <mat-icon>inventory_2</mat-icon>
            <h3>No hay productos vendidos en el periodo seleccionado</h3>
            <p>Selecciona un proveedor y un rango de fechas para ver los productos vendidos.</p>
          </div>

          <!-- Mensaje cuando no hay cortes -->
          <div class="empty-state" *ngIf="cortes.length === 0 && !loadingCortes && filterForm.get('proveedorId')?.value">
            <mat-icon>receipt_long</mat-icon>
            <h3>No hay cortes creados</h3>
            <p>No se han creado cortes para este proveedor en el periodo seleccionado.</p>
          </div>
        </div>
      </ng-container>

      <ng-template #emptyTemplate>
        <div class="empty-state" *ngIf="!loadingProductos && !filterForm.get('proveedorId')?.value">
          <mat-icon>store</mat-icon>
          <h3>Selecciona un proveedor para comenzar</h3>
          <p>Elige un proveedor del menú desplegable para ver sus productos vendidos y gestionar los cortes.</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>

